import React, { useState, useContext } from 'react';
import { IconButton, Badge } from '@mui/material';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { NotificationContext } from '../../contexts/NotificationContext';
import NotificationDropdown from './NotificationDropdown';

const NotificationBell = () => {
  const { unreadCount } = useContext(NotificationContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label={`${unreadCount} unread notifications`}
        sx={{
          color: 'text.secondary',
          transition: 'all 0.2s ease',
          '&:hover': { color: 'primary.main', backgroundColor: 'rgba(44,123,229,0.08)' },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          sx={{
            '& .MuiBadge-badge': {
              fontSize: '0.625rem',
              minWidth: 18,
              height: 18,
              fontWeight: 700,
            },
          }}
        >
          <NotificationsOutlinedIcon fontSize="small" />
        </Badge>
      </IconButton>

      <NotificationDropdown
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default NotificationBell;
